import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import MobileMenuSection from './mobile-menu-section'
import type { NavbarSection } from '../../config/navbar-data'

interface MobileNavSectionProps {
  title: string
  value: string
  sections: NavbarSection[]
  onItemClick?: () => void
}

export default function MobileNavSection({ title, value, sections, onItemClick }: MobileNavSectionProps) {
  return (
    <AccordionItem value={value} className="border-b">
      <AccordionTrigger className="font-nav text-muted-foreground hover:text-primary hover:bg-accent/80 data-[state=open]:text-primary data-[state=open]:bg-accent/50 rounded-lg px-2 py-3 text-xl font-semibold hover:no-underline">
        {title}
      </AccordionTrigger>
      <AccordionContent>
        <MobileMenuSection
          sections={sections}
          onItemClick={onItemClick}
          defaultOpen={false}
        />
      </AccordionContent>
    </AccordionItem>
  )
}
